<template>
    <NavBar />
    <div class=" justify-center mt-5 px-10">
        <div class="mb-12 flex justify-center">
            <h2 class="text-5xl font-redHat font-bold">Tambah PO</h2>
        </div>
        <form @submit.prevent="insert">
            <div class="mb-20 px-6">
                <div class="mb-4">
                    <label for="no_po" class="block font-redHat text-[#8F8F8F] font-medium font-2xl mb-2">Nomor
                        PO</label>
                    <input type="text" class="block w-full border-1 border-[#5FBAE6] rounded-md p-2" name="no_po"
                        placeholder="auto" disabled>

                </div>
                <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 mb-4 ">
                    <div class=" ">
                        <div class="w-100">

                            <label for="kode-produk"
                                class="block font-redHat text-[#8F8F8F] font-medium font-2xl mb-2">Periode PO</label>
                            <div class="flex gap-3 items-center w-100">

                                <div class="w-1/2">

                                    <input type="date" v-model="currentData.start_date" name="date" id="date"
                                        class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                                </div>
                                <div class="w-fill">
                                    -
                                </div>
                                <div class="w-1/2">

                                    <!-- <label for="kode-produk" class="block font-redHat text-[#8F8F8F] font-medium font-2xl mb-2">Periode PO</label> -->
                                    <input type="date" v-model="currentData.end_date" name="date" id="date"
                                        :min="currentData.start_date"
                                        class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- <div class="mb-5 ">
                        <label for="date" class="mb-3 block text-base font-medium text-[#07074D]">
                            for
                        </label>
                        <input type="date" name="date" id="date"
                            class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                    </div> -->








                </div>

                <div class="mb-3">
                    <label class="block font-redHat text-[#8F8F8F] font-medium font-2xl mb-2">Lokasi PO</label>
                    <!-- <input type="text" class="block w-full border-1 border-[#5FBAE6] rounded-md p-2" name="kode-produk" placeholder=""> -->
                    <multiselect v-model="currentData.id_location" :options="dataLokasi" :custom-label="nameWithLang"
                        placeholder="" label="name" track-by="" :selectLabel="''" :deselectLabel="''"
                        class="multiselect-full-width"></multiselect>
                </div>


                <div class="mb-3">
                    <label for="dropdown" class="block font-redHat font-2xl font-medium text-[#8F8F8F]">Mata
                        Uang</label>
                    <input type="text" v-model="currency" class="block w-full border-1 border-[#5FBAE6] rounded-md p-2"
                        :placeholder="currency ? currency : 'Currency will appear here'" disabled>

                </div>
                <div class="d-flex ">
                    <div class="mb-3 w-1/2 me-2">
                        <label for="dropdown"
                            class="block font-redHat font-2xl font-medium text-[#8F8F8F]">Currency</label>
                        <input type="text" v-model="currency2"
                            class="block w-full border-1 border-[#5FBAE6] rounded-md p-2"
                            :placeholder="currency2 ? currency2 : 'Currency will appear here'" disabled>
                    </div>
                    <div class="mb-3 w-1/2">
                        <label for="dropdown" class="block font-redHat font-2xl font-medium text-[#8F8F8F]">Currency
                            Rate (Rp)</label>
                        <input type="number" v-model="currentData.currency_rate" step="0.01"
                            class="block w-full border-1 border-[#5FBAE6] rounded-md p-2" placeholder="0" />
                    </div>
                </div>





            </div>

            <div class="mb-3 space-x-5 flex justify-end px-10">
                <RouterLink to="po"
                    class="bg-white text-xl font-redHat text-black text-center py-2 px-4 rounded font-bold border border-[#5FBAE6] w-[240px]">
                    Batal</RouterLink>
                <button type="submit"
                    class="bg-[#F5CA40] text-black text-xl font-redHat text-center py-2 px-4 rounded font-bold w-[240px]">Simpan</button>
            </div>
        </form>


    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import axios from "axios";
// import Swal from 'sweetalert2';
import Multiselect from 'vue-multiselect';

import { ErrorConnectionTimeOut, goPage, ShowLoading, CloseLoading, base_url, AlertPopup, AlertBottom } from "@/assets/js/function";
import Cookies from "js-cookie";


export default {
    components: {
        NavBar,
        Multiselect,

    },

    data() {
        return {
            // currentData: [],
            dataLokasi: [],
            currentData: {
                id_location: null, // This will store the selected location ID
                start_date: this.getCurrentDate(),
                end_date: this.getCurrentDate(),
            },
            // selectedLocationId: null,
            currency: '',
            // newRecord: '',
        };
    },

    created() {
        const token = Cookies.get("token");
        // console.log(token)
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 100000,
        }

        //get data
        // this.currentData = JSON.parse(localStorage.getItem('currentData'));

        // console.log(this.config);
        // this.index();
        this.dataLokasi = JSON.parse(localStorage.getItem('data_location'));



    },

    watch: {
        'currentData.id_location'(newVal) {
            // When id_location changes, find the corresponding location
            // console.log(newVal)
            const selectedLocation = this.dataLokasi.find(location => location.id === newVal.id);

            // If the location is found, update the currency
            if (selectedLocation) {
                this.currency = selectedLocation.currency;
                this.currency2 = selectedLocation.currency.split(" ")[0] + ' 1';
            } else {
                this.currency = ''; // Reset currency if no location is selected
                this.currency2 = '';
            }
        }
    },


    methods: {
        nameWithLang({ name }) {
            return `${name}`
        },

        getCurrentDate() {
            const today = new Date();
            // Format the date to YYYY-MM-DD
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },


        insert() {
            ShowLoading();
            let formData = new FormData();

            Object.entries(this.currentData).forEach(([key, value]) => {
                formData.append(key, value);
            });

            formData.delete("id_location");
            formData.append("id_location", this.currentData.id_location.id)

            // for (let [key, value] of formData.entries()) {
            //     console.log(`${key}: ${value}`);
            // }

            // console.log(this.currentData.id_location)
            // console.log(this.currentData.code_number_phone)


            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'preorder_insert';
            } else {
                this.api = base_url + 'preorder_insert';
            }

            axios
                .post(this.api, formData, this.config)
                .then((response) => {
                    // console.log(response)
                    if (response.data.status == true) {
                        AlertBottom(response.data.message);
                        goPage("po");
                        CloseLoading();
                    }
                    if (response.data.status == false) {
                        AlertPopup("error", "", response.data.message, 1500, false);
                    }
                })
                .catch((error) => {
                    ErrorConnectionTimeOut(error);
                });
        },
    },
}
</script>